module.exports = __webpack_public_path__ + "img/ChSimplified-studio.1d6e6c76.gif";